<div class="page">
    <div class="title">
        <button class="buttonBack" (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
        <div class="titleValue">{{ "issue.history" | transloco }}</div>
    </div>

    <div class="sections" *ngIf="ticket">
        <div class="header-vista">
            <div class="box-status"
                [style]="ticket.status === 'old_done' ? 'background-color: greenyellow;' : 
                            ticket.status === 'old_notdone' ? 'background-color: red; color: white' : 
                            ticket.status === 'plan' || ticket.status ==='assign' ? 
                            'background-color: blue; color: white' : 'background-color: var(--primary-color); color: white'"
                *ngIf="ticket.status">{{buscarEstadoPorNombre(ticket.status)}}</div>
        </div>
        <div class="infoLabel">{{ "issues.issueNumber" | transloco }}: <div style="font-weight: 600;">{{ticket.ID}}</div>
            </div>
        <div class="infoLabel">{{ "issues.serialNumber" | transloco }}: <div style="font-weight: 600;">{{ticket.numserie}}</div>
        </div>
        <div class="infoLabel" *ngIf="ticket.manufacturer">{{ "issue.manufacturer" | transloco }}: <div style="font-weight: 600;">
                {{ticket.manufacturer.name}}</div>
        </div>
        <div class="infoLabel" *ngIf="ticket.deviceModel">{{ "issue.model" | transloco }}: <div style="font-weight: 600;">
                {{ticket.deviceModel.name}}</div>
        </div>
        <div class="infoLabel" *ngIf="ticket.contents">{{ "issues.description" | transloco }}: <div [innerHTML]="ticket.contents"
                style="font-weight: 600;"></div>
        </div>
    </div>
    <button class="addSeguimiento" (click)="goSeguimiento()">{{ "issue.tracking.title" | transloco }}</button>
</div>